import { useState, useEffect } from 'react'

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  })
  const [isPhone, setIsPhone] = useState(false)

  useEffect(() => {
    const updateSize = () => setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    })

    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [window])

  useEffect(() => {
    if (windowSize.width <= 768) {
      setIsPhone(true)
    } else {
      setIsPhone(false)
    }
  }, [windowSize])

  return { isPhone }
}

export default useWindowSize